import useHttpProvider from "@/common/hooks/use-http";
import BluePlusIcon from "@/common/svgs/blue-plus";
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from "@/components/ui/accordion";
import * as FAQsServices from "../services/faqs";
import { useEffect, useState } from "react";
import { FAQ } from "../models/faq";
import { cn } from "@/lib/utils";

function FrequentlyAskedQuestions({ className = "" }: { className?: string }) {
	const { http } = useHttpProvider();
	const [faqs, setFaqs] = useState<FAQ[]>([]);

	const getFAQs = async () => {
		try {
			const response = await FAQsServices.getFAQs(http);
			setFaqs(response);
		} catch {}
	};

	useEffect(() => {
		getFAQs();
	}, []);

	const titleStyle = {
		background:
			"linear-gradient(161deg, #0FF1E5 3.9%, #0DAAEC 33.24%, #0823F8 72.3%, #000D74 116.02%)",
		WebkitBackgroundClip: "text",
		backgroundClip: "text",
		WebkitTextFillColor: "transparent",
	};

	return (
		<div
			className={cn(
				"bg-light flex flex-col gap-8 px-4 py-16 text-center md:gap-12 md:px-37 md:py-50",
				className
			)}
		>
			<span className="web-heading-h2">
				Frequently <span style={titleStyle}>Asked Questions</span>
			</span>

			<div className="flex flex-col justify-center md:px-69">
				<Accordion type="single" collapsible>
					{faqs.map((faq, index) => (
						<AccordionItem
							className="border-b-light-gray"
							value={`item-${index + 1}`}
							key={index}
						>
							<AccordionTrigger
								className="web-body-b1-medium [&[data-state=open]>svg]:rotate-45"
								triggerIcon={<BluePlusIcon />}
							>
								{faq.question}
							</AccordionTrigger>
							<AccordionContent className="web-body-b1 text-left text-gray-700">
								{faq.answer}
							</AccordionContent>
						</AccordionItem>
					))}
				</Accordion>
			</div>
		</div>
	);
}

export default FrequentlyAskedQuestions;
